export default function isSettlementEligible(group) {
    const { currentStep } = group.primary.settlementInfo;
    return currentStep !== "Contact" && currentStep !== "PaymentPlanAccepted";
}



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/accts/isSettlementEligible.ts